import { AddGroupCourseArgs, AddGroupUserArgs, CreateGroupArgs, EditGroupArgs, IGroup } from "../common/group";
import GroupsRepository, {IGroupsRepository} from "../repositories/groups";

export class GroupsService {
    private repository: IGroupsRepository;
    constructor(repositoriInstance: IGroupsRepository) {
        this.repository = repositoriInstance;
    }
    getGroups(): IGroup[] {
        return this.repository.getGroups();
    }
    getGroupUsers(groupId: IGroup['id']) {
        return this.repository.getGroupUsers(groupId);
    }
    addGroup(data: CreateGroupArgs): IGroup {
        return this.repository.addGroup(data);
    }
    deleteGroup(groupId: IGroup['id']) {
        return this.repository.deleteGroup(groupId);
    }
    editGroup(data: EditGroupArgs) {
        return this.repository.editGroup(data);
    }
    addGroupUser(data: AddGroupUserArgs) {
        return this.repository.addGroupUser(data);
    }
    deleteGroupUser(data: AddGroupUserArgs) {
        return this.repository.deleteGroupUser(data);
    }
    getGroupCourses(id: IGroup['id']) {
        return this.repository.getGroupCourses(id);
    }
    addGroupCourse(params: AddGroupCourseArgs) {
        return this.repository.addGroupCourse(params);
    }
    deleteGroupCourse(params: AddGroupCourseArgs) {
        return this.repository.deleteGroupCourse(params);
    }
}

const groupsService = new GroupsService(new GroupsRepository());

export default groupsService;